export default {
  'sendticket.sendticket': 'ОТПРАВИТЬ БИЛЕТ',
  'sendticket.sentsuccessfully': 'Билет успешно отправлен',
  'sendticket.replytickets': 'Ответить Билеты',
  'sendticket.you': 'Вы',
  'sendticket.operator': 'оператор',
  'sendticket.reply': 'ОТВЕТИТЬ',
  'sendticket.createdat': 'Создан в',
  'sendticket.laststatus': 'Последний статус',
  'sendticket.ticketid': 'ID билета',
  'sendticket.closeticketquestion': 'закрыть билет?',
  'sendticket.closeticket': 'Да, Закрыть этот билет',
  'sendticket.notcloseticket': 'Нет',
  'sendticket.closedsuccessfully': 'Билет успешно закрыт',
  'sendticket.downloadfile': 'Скачать файл',
  'sendticket.daysago': 'дней назад',
  'sendticket.hoursago': 'несколько часов назад',
  'sendticket.minutesago': 'минут назад',
  'sendticket.yes': 'да, был дан ответ',
  'sendticket.today': '( Сегодня )',
  'sendticket.yesterday': '( вчерашний день )',
  'sendticket.justnow': 'прямо сейчас',
};
